module.exports = "/images/vendor/flag-icon-css/flags/1x1/jp.svg?16a568ca9eb15a225e3a90aee0f68909";